<template>
  <div class="configNetPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
      <ConfigBase
        :row-data="rowData"
        :net-params="netParams"
        :coordinator="coordinator"
      ></ConfigBase>
    </div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box" v-loading="loading">
      <el-form ref="form" label-position="right" label-width="150px" label-suffix="：">
        <Config
          ref="config"
          :json-content="JsonContent"
          :mode="isClickConfig ? 'view' : 'edit'"
        ></Config>
      </el-form>
      <div class="form-actions" v-if="rowData['configStatus'] !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="baseContent.cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ baseContent.cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
      <div class="list">
        <div class="listPage" v-for="item in listArray" :key="item.id">
          <span>{{ $timetransition(item['logTime']) }}</span>
          <!-- 只能输网络参数 -->
          <span>{{ $t('integration.network_parameters') }}</span>
          <span>{{ configFn(item['stepCode']) }}</span>
          <el-button
            type="text"
            size="small"
            :title="$t('public.details')"
            icon="el-icon-tickets"
            @click="configDetailFn(item)"
          ></el-button>
        </div>
      </div>
    </div>

    <!--    />-->
    <ConfigLogDialog ref="configLogDia"></ConfigLogDialog>
  </div>
</template>

<script>
import {
  getGenTwoGatewayConfig,
  updateGenTwoGatewayConfig
} from '@/api/modules/gateway.js'
import cmdDialog from '../../../components/CmdDialog.vue'
import ConfigBase from '@/pages/equipment/gateway/modal/ConfigDialog/ConfigBase.vue'
import { RuleExtPanId, RuleRequiredFunc } from '@/utils/rules'
import Modify from '@/pages/equipment/base/components/configInfo/Modify.vue'
import Config from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/component/Config.vue'
import ConfigLogDialog from '@/pages/equipment/gateway/modal/ConfigDialog/ConfigLogDialog.vue'
import { configStep } from '@/utils/convert'

export default {
  // 行数据 以及是否属于网关协调器
  props: {
    rowData: {},
    coordinator: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Config,
    Modify,
    cmdDialog,
    ConfigBase,
    ConfigLogDialog
  },

  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.gateway_name',
          key: 'name'
        },
        {
          text: 'Mac',
          key: 'mac'
        },
        {
          text: 'device.config_status',
          key: 'config_status'
        },

        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'public.type',
          key: 'type'
        }
      ],
      baseContent: {},
      JsonContent: {},

      listArray: [],
      isClickConfig: true,

      loading: false,

      // 请求回来的网络参数
      netParams: {}
    }
  },
  activated () {
    if (this.$attrs.sensorWay !== 'bind' && this.$attrs.sensorWay !== 'stop') {
      this.baseMsg.splice(-2, 1)
    }
    this.httpUrlFn()
  },
  methods: {
    RuleRequiredFunc,
    RuleExtPanId () {
      return RuleExtPanId
    },
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },
    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async configSave () {
      const data = await this.$refs.config.getData()
      this.loading = true
      const query = {
        ...data,
        idList: [this.rowData.id]
      }
      // 记录保存前的 content，用于轮询时检测后端是否已写入新数据
      const oldContent = this.netParams ? this.netParams.content : null
      try {
        const { result, state } = await updateGenTwoGatewayConfig(query)
        if (result && state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          // 后端队列异步消费，轮询直到 content 变化才切换视图
          await this.refreshAfterSave(oldContent)
          this.isClickConfig = !this.isClickConfig
        } else {
          this.$message.error(state.msg)
        }
      } finally {
        this.loading = false
      }
    },
    // 保存后轮询刷新，等待后端队列消费完成写入数据库（通过比较 content 是否变化判断）
    refreshAfterSave (oldContent, retries = 10) {
      return new Promise((resolve) => {
        const attempt = (remaining) => {
          setTimeout(() => {
            this.httpUrlFn()
              .then(() => {
                const newContent = this.netParams ? this.netParams.content : null
                // content 变化说明后端已写入新数据
                if (newContent && newContent !== oldContent) {
                  resolve()
                } else if (remaining > 0) {
                  attempt(remaining - 1)
                } else {
                  resolve()
                }
              })
              .catch(() => {
                if (remaining > 0) {
                  attempt(remaining - 1)
                } else {
                  resolve()
                }
              })
          }, 500)
        }
        attempt(retries)
      })
    },
    httpUrlFn () {
      return getGenTwoGatewayConfig({ gatewayId: this.rowData.id }).then(
        ({ result }) => {
          if (result) {
            this.netParams = result

            if (result.content) {
              const JsonContent = JSON.parse(result.content)
              this.baseContent.cmd = JsonContent.cmd
              this.JsonContent = JsonContent
              console.log(JsonContent)
            }
            this.listArray = result.responseDeviceConfigLogList
          }
        }
      )
    },

    configFn (value) {
      return this.$t(configStep[value].title)
    },
    configDetailFn (row) {
      this.$refs.configLogDia.open(this.rowData, row)
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;

    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cmd-text {
    word-break: break-all;
    font-family: Consolas, Monaco, monospace;
    color: #303133;
  }
}
</style>
